export const SET_PROPERTY_LOADING = 'SET_PROPERTY_LOADING';
export const GET_PROERTIES = '[Property Action] Get properties';
export const CONFIRMED_GET_PROERTIES = '[Property Action] Confirmed Get properties';
export const CONFIRMED_GET_FILTERS = '[Property Action] Confirmed Get filters';
export const CONFIRMED_GET_PROPERTY = '[Property Action] Confirmed Get property';
export const CONFIRMED_GET_REPORTED_ADS = '[Property Action] Confirmed Get reported ads';
